import { PropsWithChildren } from "react";

import styles from "./Layout.module.css";
type Props = {};

export const Main = ({ children }: PropsWithChildren<Props>) => {
  return <div className={styles.main}>{children}</div>;
};
